import { createFileRoute } from '@tanstack/react-router';
import { SuggestionScreen } from '../features/friends/SuggestionScreen.tsx';

export const Route = createFileRoute('/inbox/$id')({ component: SuggestionRoute });

function SuggestionRoute() {
  const { id } = Route.useParams();
  return <SuggestionScreen id={id} />;
}
